import React from 'react';
import './styles/dashboardToggle.scss';
import { TabItem } from '@/features/GameWindow/Dashboard.tsx';
import { SHOWOFF_ELEMENTS } from '@/features/Showoff';
import {
  TRACK_USER_ACTION_EVENT,
  useTrackUserAction,
} from '@/utilities/logger/amplitude/tracking';

type TabType = 'dashboard' | 'game_help';

const SHOWOFF_TAB_MAP: Record<TabType, string> = {
  dashboard: SHOWOFF_ELEMENTS.DASHBOARD_BUTTON,
  game_help: SHOWOFF_ELEMENTS.GAME_HELP_BUTTON,
};

const ZONE_BY_TAB: Record<TabType, 'DASHBOARD' | 'GAME_HELP'> = {
  dashboard: 'DASHBOARD',
  game_help: 'GAME_HELP',
};

export const DashboardToggle: React.FC<{
  tabs: TabItem[];
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
}> = ({ activeTab, onTabChange, tabs }) => {
  const { trackUserAction } = useTrackUserAction();

  const handleTabClick = (tab: TabType) => {
    if (tab !== activeTab) {
      trackUserAction({
        event: TRACK_USER_ACTION_EVENT.IN_GAME_ZONE_VIEWED,
        zone: ZONE_BY_TAB[tab],
      });
    }
    onTabChange(tab);
  };

  return (
    <div className="content-toggle-nav">
      {tabs.map((tab) => {
        const navKey = tab.type.replace(/_/g, '-');
        return (
          <div
            key={tab.type}
            className="nav-item-container"
            onClick={() => handleTabClick(tab.type)}
            data-testid={`${navKey}-nav-item`}
          >
            <div
              className={`nav-item ${activeTab === tab.type ? 'highlight' : ''}`}
              data-showoff={SHOWOFF_TAB_MAP[tab.type]}
              data-showoff-notification="false"
            >
              <div className="title-icon">{tab.icon}</div>
              <div className="title" data-testid={`${navKey}-nav-title`}>
                {tab.title}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
